export const ORGANIC_LEAD_SOURCE = 'unipile-organic';
export const ORGANIC_CAMPAIGN_ORIGIN = 'organic';

export function isOrganicLead(lead) {
  return String(lead?.source || '').toLowerCase() === ORGANIC_LEAD_SOURCE;
}

export function isOrganicCampaign(campaign) {
  return String(campaign?.origin || '').toLowerCase() === ORGANIC_CAMPAIGN_ORIGIN;
}
